// Barra de progreso para operaciones largas de IA (U5). Las llamadas al reasoner
// tardan 20–40 s con solo un spinner; esto da una barra que avanza hacia ~95%
// sobre el tiempo estimado (nunca llega a 100 hasta que termina) + un texto de
// expectativa, para que el usuario sepa que el sistema está trabajando.
import { useEffect, useState } from "react";

export function AiProgress({
  estimateSec = 25,
  label = "La IA está razonando…",
}: {
  estimateSec?: number;
  label?: string;
}) {
  const [pct, setPct] = useState(6);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => {
      const elapsed = (Date.now() - start) / 1000;
      // Curva que se acerca asintóticamente a 95% en ~estimateSec.
      const target = 95 * (1 - Math.exp(-elapsed / (estimateSec / 3)));
      setPct(Math.min(95, Math.max(6, target)));
    }, 200);
    return () => clearInterval(id);
  }, [estimateSec]);

  return (
    <div className="space-y-1.5" role="status" aria-live="polite">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--color-surface-2)]">
        <div
          className="h-full rounded-full bg-[var(--color-blue)] transition-[width] duration-200 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex items-center justify-between text-[11px] text-[var(--color-text-muted)]">
        <span>{label}</span>
        <span className="font-[var(--font-mono)]">~{estimateSec}s</span>
      </div>
    </div>
  );
}
